<template>
  <div class="content-width py-4">
    <div class="caed bg-white">
      <div class="card-body">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group class="variant-cms" label="報表類型">
            <b-form-radio-group
              id=""
              v-model="form.selected"
              :options="options"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
          <ManageDateRangePicker
            @childMethod="getDateRangePicker"
            :state="state.sease_term"
            :group_class="'required'"
            :startDate="form.date_start"
            :endDate="form.date_end"
            startName="起始日期"
            endName="結束日期"
            layout="6"
          ></ManageDateRangePicker>
          <div class="row" v-if="form.selected == 'order'">
            <div class="col-md-6">
              <b-form-group label="訂購公司" label-for="">
                <b-form-input
                  id=""
                  class="rounded-0"
                  v-model="form.company_name"
                  type="text"
                  placeholder="公司名稱"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="業務員" label-for="">
                <b-form-select
                  class="rounded-0 col"
                  v-model="form.vendor_id"
                  id=""
                >
                  <b-form-select-option value="" selected
                    >請選擇</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="item in salesList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="付款狀態" label-for="">
                <b-form-select
                  class="rounded-0 col"
                  v-model="form.pay_status"
                  id=""
                >
                  <b-form-select-option value="" selected
                    >請選擇</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="item in payStatusList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="出貨狀態" label-for="">
                <b-form-select
                  class="rounded-0 col"
                  v-model="form.shopping_status"
                  id=""
                >
                  <b-form-select-option value="" selected
                    >請選擇</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="item in shoppingStatusList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-6">
              <b-form-group label="零件分類" label-for="">
                <b-form-select
                  class="rounded-0 col"
                  v-model="form.category"
                  id=""
                >
                  <b-form-select-option value="" selected
                    >請選擇</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="item in partCategoryList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <b-button squared variant="cms_main" type="submit" class="mr-3 mt-3"
            >匯出報表</b-button
          >
          <b-button
            squared
            type="button"
            @click="onReset"
            variant="outline-secondary"
            class="mt-3"
            >重置</b-button
          >
        </b-form>
      </div>
    </div>
    <div class="onload-view" :class="{ show: onloadViewShow }">
      <div class="onload-icon text-center">
        <b-icon
          icon="arrow-clockwise"
          animation="spin-pulse"
          font-scale="4"
        ></b-icon>
        <p class="mt-2">下載中</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.onload {
  &-view {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(#fff, 0.8);
    z-index: 101;
    display: none;
    opacity: 0;
    &.show {
      display: block;
      animation-name: oxxo;
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }
  }
  &-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #7b7b7b;
  }
}
@keyframes oxxo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<script>
import ManageDateRangePicker from "@/components/DateRangePicker.vue";
import { Toast } from "@/plugins/sweetalert2.js";
import { Product, Account, Report } from "@/assets/api/cms.js";

export default {
  name: "Report",
  props: ["page_name", "token"],
  components: { ManageDateRangePicker },
  data() {
    return {
      options: [
        { text: "訂單報表", value: "order" },
        { text: "零件銷售報表", value: "part" }
      ],
      payStatusList: [
        { id: "0", name: "未付款" },
        { id: "2", name: "部分付款" },
        { id: "1", name: "已付款" }
      ],
      shoppingStatusList: [
        { id: "0", name: "未出貨" },
        { id: "2", name: "部分出貨" },
        { id: "1", name: "已出貨" }
      ],
      salesList: null,
      partCategoryList: null,
      state: {
        sease_term: null
      },
      form: {
        selected: "order",
        date_start: "",
        date_end: "",
        company_name: "",
        vendor_id: "",
        pay_status: "",
        shopping_status: "",
        category: ""
      },
      reportId: null,
      onloadViewShow: false
    };
  },
  created() {
    Account.get("", this.token)
      .then(res => {
        if (res.status <= 201) {
          this.salesList = res.data.Sales;
        } else {
          Toast.fire({
            icon: "error",
            title: "權限狀態讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Product.getTag(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.partCategoryList = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "零件分類資料取得失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    reportId(newData) {
      if (newData == null) return;
      this.getReport(newData);
    }
  },
  methods: {
    getDateRangePicker(data) {
      this.form.date_start = data.startDate;
      this.form.date_end = data.endDate;
    },
    getReport(reportId) {
      this.onloadViewShow = true;
      Report.get(reportId, this.token).then(res => {
        switch (res.data.status) {
          case "failed":
            this.onloadViewShow = false;
            Toast.fire({
              icon: "error",
              title: "報表匯出失敗",
              text: res.data.error
            });
            break;
          case "pending":
            setTimeout(() => {
              this.getReport(reportId);
            }, 3000);
            break;
          case "success":
            this.onloadViewShow = false;
            window.location.assign(res.data.downloadLink);
            break;
          default:
            break;
        }
      });
    },
    onSubmit() {
      this.form.date_start && this.form.date_end
        ? (this.state.sease_term = null)
        : (this.state.sease_term = false);

      if (this.state.sease_term == false) return;

      this.reportId = null;
      let data = {};
      if (this.form.selected == "order") {
        data = Object.assign({}, this.form);
        delete data.selected;
        delete data.category;

        for (const value of Object.keys(data)) {
          if (data[value] === "") {
            delete data[value];
          }
        }

        Report.order(data, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.reportId = res.data.data.reportId;
            } else {
              Toast.fire({
                icon: "error",
                title: "報表匯出失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        data.date_start = this.form.date_start;
        data.date_end = this.form.date_end;
        data.category = this.form.category;

        Report.part(data, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.reportId = res.data.data.reportId;
            } else {
              Toast.fire({
                icon: "error",
                title: "報表匯出失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    onReset() {
      this.form.date_start = "";
      this.form.date_end = "";
      this.form.company_name = "";
      this.form.vendor_id = "";
      this.form.pay_status = "";
      this.form.shopping_status = "";
      this.form.category = "";
    }
  }
};
</script>
